import {
    TextHelper,
    //SmallTextHelper,
    UrlHelper,
    ArrayHelper,
    NumberHelper
} from '../../PrismicHelpers';

export const packagesSliceArray = (data) => {
    // Always take the slice_type and return it with data, helper will know what to display/render
    const dataType = data.slice_type;
    // Non repetable data inside slice
    //const sliceFixedData = data.primary;
    // Repetable data (example: buttons)
    const sliceRepetableData = data.items;
    // Data to send to the array of slices (always type and data if needed)
    let dataToSend = {
        type: dataType,
        packages: !(sliceRepetableData && sliceRepetableData.length > 0) ? null : sliceRepetableData.map(element => {
            if (element.package_uid && element.package_uid.id) return element.package_uid.id
        }),
        packagesWithRecommended: !(sliceRepetableData && sliceRepetableData.length > 0) ? null : sliceRepetableData.map(element => {
            if (element.package_uid && element.package_uid.id) return {
                id: element.package_uid.id,
                is_recommended: element.is_recommended
            }
        })
    };

    if(!dataToSend.packages) return null;

    return dataToSend
}

export const productsSliceArray = (data) => {
    // Always take the slice_type and return it with data, helper will know what to display/render
    const dataType = data.slice_type;
    // Non repetable data inside slice
    //const sliceFixedData = data.primary;
    // Repetable data (example: buttons)
    const sliceRepetableData = data.items;

    // Data to send to the array of slices (always type and data if needed)
    let dataToSend = {
        type: dataType,
        products: !(sliceRepetableData && sliceRepetableData.length > 0) ? null : sliceRepetableData.map(element => {
            if (element.product && element.product.id) return element.product.id
        }),
        productBgColour: !(sliceRepetableData && sliceRepetableData.length > 0) ? null : sliceRepetableData.map(element => {
            if (element.product && element.product.id) return {
                id: element.product.id,
                bg_colour: element.background_colour
            }
        })
    };

    if(!dataToSend.products) return null;

    return dataToSend
}

export const packagesSliceRelationship = (data, packagesWithRecommended, sliceType) => {
    // Always take the slice_type and return it with data, helper will know what to display/render
    const dataType = sliceType;
    // Non repetable data inside slice
    //const sliceFixedData = data.primary;
    // Repetable data (example: buttons)
    const sliceRepetableData = data.results;
    // Data to send to the array of slices (always type and data if needed)
    let dataToSend = {
        type: dataType,
        packages: !(sliceRepetableData && sliceRepetableData.length > 0) ? null : sliceRepetableData.map(element => {
            return {
                id: element.id,
                currency_sign: TextHelper(element.data.currency_sign),
                icon: UrlHelper(element.data.icon),
                name: TextHelper(element.data.name),
                price: NumberHelper(element.data.price),
                price_small: TextHelper(element.data.price_small),
                text_under_icon: TextHelper(element.data.text_under_icon),
                text_under_price: TextHelper(element.data.text_under_price),
                product_payment_uid: element.data.product_payment_uid.uid ? element.data.product_payment_uid.uid : null,
                features: (!element.data.features || !element.data.features.length > 0) ? null : element.data.features.map(feature => {
                    return {
                        name: TextHelper(feature.feature_name),
                        description: ArrayHelper(feature.feature_description)
                    }
                })
            }
        })
    };

    if(dataToSend.packages && dataToSend.packages.length > 0) {
        dataToSend.packages = dataToSend.packages.map(singlePackage => {
            return {
                ...singlePackage,
                is_recommended: packagesWithRecommended.find(objectWithRecommended => {
                    if(singlePackage.id === objectWithRecommended.id) return true;
                })
            }
        })
    }

    return {...dataToSend }
}

export const productsSliceRelationship = (data, productBgColour, sliceType) => {
    // Always take the slice_type and return it with data, helper will know what to display/render
    const dataType = sliceType;
    // Non repetable data inside slice
    //const sliceFixedData = data.primary;
    // Repetable data (example: buttons)
    const sliceRepetableData = data.results;
    // Data to send to the array of slices (always type and data if needed)
    let dataToSend = {
        type: dataType,
        products: !(sliceRepetableData && sliceRepetableData.length > 0) ? null : sliceRepetableData.map(element => {
            return {
                id: element.id,
                currency_sign: TextHelper(element.data.currency_symbol),
                image: UrlHelper(element.data.product_image),
                name: TextHelper(element.data.product_name),
                price: TextHelper(element.data.price),
                description: ArrayHelper(element.data.product_description),
                button_label: TextHelper(element.data.button_label),
                //product_payment_uid: element.data.stripe_form.uid ? element.data.stripe_form.uid : null,
                url: UrlHelper(element.data.url)
            }
        })
    };

    if(dataToSend.products && dataToSend.products.length > 0) {
        dataToSend.products = dataToSend.products.map(singleProduct => {
            return {
                ...singleProduct,
                bg_colour: productBgColour
            }
        })
    }

    return {...dataToSend}
}



// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/prismic-slice-helpers/single-slice-helpers/productsSlice.js